import { useMemo } from 'react';

import PropertyValue from '@/components/Typography/PropertyValue';
import { NOT_ASSIGNED_LABEL } from '@/configs/reserved-word';
import SentimentBadge from '@/features/Feedback/field/Sentiment/SentimentBadge';
import type { FeedbackSentiment } from '@/types/feedbackConst';
import { isEmptyArray } from '@/utils/util';

import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const SentimentField = (
  props: CommonFieldProps & {
    feedback_alias: string;
    sentiment_detail?: FeedbackSentiment[];
  },
) => {
  const uniqueSentimentList = useMemo(() => {
    return [...new Set(props.sentiment_detail)];
  }, [props.sentiment_detail]);

  if (!props.showFull && isEmptyArray(uniqueSentimentList)) return null;

  return (
    <PropertyRowWrapper {...props} expandable>
      {uniqueSentimentList.length === 0 && (
        <PropertyValue placeholder={NOT_ASSIGNED_LABEL} />
      )}
      {uniqueSentimentList.map((sentiment) => (
        <PropertyValue
          key={sentiment}
          value={<SentimentBadge type={sentiment} />}
        />
      ))}
    </PropertyRowWrapper>
  );
};
